import React from "react";
import EmojiSelector from "./EmojiSelector";
import FeedbackTextArea from "./FeedbackTextArea";
import SubmitButton from "./SubmitButton";
import { countWords } from "../../../utils/text";
import PoweredByFeedaura from "./PoweredByFeedaura";

interface FeedbackFormProps {
  feedback: { text: string; emoji: string };
  setFeedback: React.Dispatch<React.SetStateAction<{ text: string; emoji: string }>>;
  errorMsg: string;
  setErrorMsg: React.Dispatch<React.SetStateAction<string>>;
  primaryColor: string;
  placeholder: string;
  feedbackLabel: string;
  submitText: string;
  isSubmitting: boolean;
  onSubmit: () => void;
  questionText: string;
}

const FeedbackForm: React.FC<FeedbackFormProps> = ({
  feedback,
  setFeedback,
  errorMsg,
  setErrorMsg,
  placeholder,
  feedbackLabel,
  submitText,
  isSubmitting,
  onSubmit,
  questionText,
  primaryColor
}) => {
  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newText = e.target.value;

    if (newText.length > 200) {
      setErrorMsg("Feedback text cannot exceed 200 words.");
      return;
    }
    setErrorMsg("");
    setFeedback((prev) => ({ ...prev, text: newText }));
  };



  return (
    <>
      <div className="feedback-question">
        <p>{questionText}</p>
      </div>
      <EmojiSelector
        selectedEmoji={feedback.emoji}
        onSelectEmoji={(value) =>
          setFeedback((prev) => ({ ...prev, emoji: prev.emoji === value ? "" : value }))
        }
      />
      <FeedbackTextArea
        value={feedback.text}
        onChange={handleTextChange}
        errorMsg={errorMsg}
        placeholder={placeholder}
        label={feedbackLabel}
      />
      <div className="feedback-actions">
        <SubmitButton
          isSubmitting={isSubmitting}
          disabled={isSubmitting || !feedback.text.trim() || Boolean(errorMsg)}
          onClick={onSubmit}
          primaryColor={primaryColor}
          submitText={submitText}
        />
      </div>
      <PoweredByFeedaura primaryColor={primaryColor} />
    </>
  );
};

export default FeedbackForm;
